import React, { useState } from 'react'
import styles from '../TrainMachine.module.css'
import renderPrgImage from '../../../../source/programImg'

function TrainingPanel({
    currentModel,
    classes,
    startTraining,
    showEpochsHelp,
    showBatchHelp,
    onEpochsChange,
    onBatchSizeChange,
    onReset,
    onTrain,
    onShowEpochsHelp,
    onHideEpochsHelp,
    onShowBatchHelp,
    onHideBatchHelp,
}) {
    const [showTrainTooltip, setShowTrainTooltip] = useState(false)
    return (
        <>
            {' '}
            <div className={styles.advanceDiv}>
                <div className={styles.epochsDiv}>
                    <div className={styles.epochsDivInr}>
                        <p style={{ marginBottom: '0' }}>Epochs:</p>
                        <input
                            type="number"
                            value={currentModel?.epochs ?? 20}
                            onChange={onEpochsChange}
                        />
                        <div
                            style={{
                                position: 'relative',
                                textAlign: 'right',
                                width: '25px',
                            }}
                            onMouseEnter={onShowEpochsHelp}
                            onMouseLeave={onHideEpochsHelp}
                        >
                            <img
                                width={'20px'}
                                src={renderPrgImage('questionPng')}
                                alt="arrow down"
                            />
                            <div
                                className={`${styles.epochsHelpDiv} ${
                                    showEpochsHelp
                                        ? styles.epochsHelpDivShow
                                        : ''
                                }`}
                            >
                                <p>
                                    One epoch means that each and every sample
                                    in the training dataset has been fed through
                                    the training model at least once. If your
                                    epochs are set to 20, for example, it means
                                    that the model you are training will work
                                    through the entire training dataset 20
                                    times. Generally the larger the number, the
                                    better your model will learn to predict the
                                    data.
                                </p>
                                <p>
                                    You probably want to tweak (usually
                                    increase) this number until you get good
                                    predictive results with your model.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.batchDiv}>
                    <div className={styles.batchDivInr}>
                        <p style={{ marginBottom: '0' }}>Batch Size:</p>

                        <select
                            value={currentModel?.batchSize ?? 16}
                            onChange={onBatchSizeChange}
                        >
                            <option value="16">16</option>
                            <option value="32">32</option>
                            <option value="64">64</option>
                            <option value="128">128</option>
                            <option value="256">256</option>
                            <option value="512">512</option>
                        </select>
                        <div
                            style={{
                                position: 'relative',
                                textAlign: 'right',
                                width: '25px',
                            }}
                            onMouseEnter={onShowBatchHelp}
                            onMouseLeave={onHideBatchHelp}
                        >
                            <img
                                width={'20px'}
                                src={renderPrgImage('questionPng')}
                                alt="arrow down"
                            />
                            <div
                                className={`${styles.batchHelpDiv} ${
                                    showBatchHelp
                                        ? styles.epochsHelpDivShow
                                        : ''
                                }`}
                            >
                                <p>
                                    A batch is a set of samples used in one
                                    iteration of training. For example, let's
                                    say that you have 80 images and you choose a
                                    batch size of 16. This means the data will
                                    be split into 80 / 16 = 5 batches. Once all
                                    5 batches have been fed through the model,
                                    exactly one epoch will be complete.
                                </p>
                                <p>
                                    You probably won't need to tweak this number
                                    to get good training results.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.resetDiv}>
                    <div onClick={onReset} className={styles.resetDivInr}>
                        <p style={{ marginBottom: '0' }}>Reset Defaults</p>
                        <img
                            width={'20px'}
                            src={renderPrgImage('reset')}
                            alt="arrow down"
                        />
                    </div>
                </div>
            </div>
            <div style={{ position: 'relative' }}>
                <div
                    style={{ position: 'relative', display: 'inline-block' }}
                    onMouseEnter={() => setShowTrainTooltip(true)}
                    onMouseLeave={() => setShowTrainTooltip(false)}
                >
                    <p
                        onClick={() => {
                            if (startTraining) return
                            if (Object.keys(classes).length < 2) return
                            onTrain()
                        }}
                        className={styles['train_right_tainButton']}
                        style={
                            startTraining || Object.keys(classes).length < 2
                                ? {
                                      opacity: '0.5',
                                      cursor: 'default',
                                  }
                                : { cursor: 'pointer' }
                        }
                    >
                        {startTraining ? 'Training...' : 'Train Model'}
                    </p>

                    {Object.keys(classes).length < 2 && showTrainTooltip && (
                        <div
                            style={{
                                position: 'absolute',
                                top: 'calc(100% + 8px)',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                background: 'rgba(0,0,0,0.85)',
                                color: '#fff',
                                padding: '8px 10px',
                                borderRadius: '6px',
                                fontSize: '16px',
                                whiteSpace: 'nowrap',
                                pointerEvents: 'none',
                                zIndex: 1000,
                            }}
                        >
                            Need at least two classes to train
                        </div>
                    )}
                </div>

                {/* {startTraining && (
                    <div
                        className={styles['trainLodarStyle']}
                        style={{}}
                    >
                        <ColorRing />
                    </div>
                )} */}
            </div>
        </>
    )
}

export default TrainingPanel
